import React, { Component } from 'react';
import DateTime from 'react-datetime';
import Overlay from '../../../../presentation/Overlay';
import { 
  Dialog, 
  DialogHeader, 
  DialogBody, 
  DialogFooter, 
  DialogPanel, 
  DialogPanelControl
} from '../../../../presentation/Dialog';

import Comparison from '../../../../prototypes/Comparison';

class Lp247GrossMedSalesDialog extends Component {
  constructor( props ) {
    super( props );
    
    this.EditModes = {
      VIEW: 0,
      INSERT: 1,
      UPDATE: 2
    };

    this.state = {
      show: props.show === undefined ? false : props.show,
      row: props.row === undefined ? { DATE: 0, SALES: 0, ADJUSTED_SALES: 0} : props.row,
      mode: props.mode === undefined ? this.EditModes.VIEW : props.mode
    };
  }

  static getDerivedStateFromProps = ( props, state ) => { 
    let newState = state;
    let stateChanged = false;
    
    if( props.show !== undefined ) {
      if( props.show !== state.show ) {
        newState.show = props.show;
        stateChanged = true;
      }
    }

    if( props.row !== undefined ) {
      let compare = new Comparison( props.row, state.row );
      if( compare.isMatch( compare.MatchTypes.DataRow ) === false ) {
        newState.row = props.row;
        stateChanged = true;
      }
    }

    if( props.mode !== undefined ) {
      if( props.mode !== state.mode ) {
        newState.mode = props.mode;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  getCaption = ( ) => { 
    const row = this.state.row;
    if( row !== undefined ) {
      if( row.DATE !== undefined ) {
        if( this.state.mode === this.EditModes.INSERT ) {
          return "CREATE NEW SALE";
        } else if( this.state.mode === this.EditModes.UPDATE ) {
          return "MODIFY SALE FOR: " + row.DATE.toString();
        } else {
          return "VIEW SALES FOR: " + row.DATE.toString();
        }
      }
    }
    return "ERROR";
  }

  getDateControl = ( ) => { 
    if( this.state.mode === this.EditModes.INSERT ) {
      return (
        <DialogPanelControl width="98%" height="50px" >
          <span style={{"minWidth":"100px"}}>
            DATE
          </span>
          <DateTime 
            id="DATE"
            value={this.state.row.DATE} 
            closeOnSelect={true}
            defaultValue={this.state.row.DATE}
            viewDate={this.state.row.DATE}
            dateFormat="YYYY-MM-DD"
            timeFormat={false}
            onChange={this.onChangeDate}
            disableCloseOnClickOutside={false}
          />
        </DialogPanelControl>
      );
    } else if( this.state.mode === this.EditModes.UPDATE ) {
      return (
        <DialogPanelControl width="98%" height="50px" >
          <span style={{"minWidth":"100px"}}>
            DATE
          </span>
          <span style={{"minWidth":"100px"}}>
            {this.state.row.DATE}
          </span>
        </DialogPanelControl>
      );
    } else {
      return (
        <DialogPanelControl width="98%" height="50px" >
          <span style={{"minWidth":"100px"}}>
            DATE
          </span>
          <span style={{"minWidth":"100px"}}>
            {this.state.row.DATE}
          </span>
        </DialogPanelControl>
      );
    }
  }

  onChangeDate = ( dateTime ) => {
    let updatedRow = this.state.row;
    updatedRow[ "DATE" ] = dateTime.format("YYYY-MM-DD");
    this.setState( { 
      row: updatedRow
    } );
  }

  onChange = ( e ) => { 
    const id = e.target.id;
    let updatedRow = this.state.row;
    updatedRow[ id ] = e.target.value;
    this.setState( { 
      row: updatedRow
    } );
  }

  onSave = ( e ) => { 
    if( this.props.onSave !== undefined ) {
      e.row = this.state.row;
      this.props.onSave( e );
    }
  }

  onClose = ( e ) => {
    if( this.props.onClose !== undefined ) {
      this.props.onClose( e ) ;
    }
  }

  render( ) {
    let caption = this.getCaption();
    let dateControl = this.getDateControl();
    return (
      <div>
        <Dialog show={this.state.show} width={35} height={45} >
          <DialogHeader caption={caption} closeButton onClose={this.onClose} />
          <DialogBody>
            <DialogPanel>
              <DialogPanelControl width="98%" height="50px" >
                {dateControl}
              </DialogPanelControl>
              <DialogPanelControl width="98%" height="50px" >
                <span style={{"minWidth":"100px"}}>
                  SALES
                </span>
                <input id="SALES" type="textbox" value={this.state.row.SALES} onChange={this.onChange} style={{"width":"200px"}} />
              </DialogPanelControl>
              <DialogPanelControl width="98%" height="50px" >
                <span style={{"minWidth":"100px"}}>
                  ADJUSTED
                </span>
                <input id="ADJUSTED_SALES" type="textbox" value={this.state.row.ADJUSTED_SALES} onChange={this.onChange} style={{"width":"200px"}} />
              </DialogPanelControl>
            </DialogPanel>
          </DialogBody>
          <DialogFooter>
            <button className="dialog-save-button" onClick={this.onSave}>
              Save
            </button>
            <button className="dialog-cancel-button" onClick={this.onClose}>
              Cancel
            </button>
          </DialogFooter>
        </Dialog>
        <Overlay show={this.state.show} />
      </div>
    );   
  }
}

export default Lp247GrossMedSalesDialog;


// WEBPACK FOOTER //
// ./src/content/accounting/lp247/components/Lp247GrossMedSalesDialog.js